function CheckedIcon() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17 3C19.2091 3 21 4.79086 21 7V17C21 19.2091 19.2091 21 17 21H7C4.79087 21 3.00002 19.2091 3 17V7C3 4.79086 4.79086 3 7 3H17ZM16.4199 8.82422C16.0795 8.5072 15.5486 8.5285 15.2344 8.87207L10.8213 13.7002L8.24902 10.8525C7.93679 10.5069 7.40583 10.4826 7.06348 10.7979C6.72142 11.1131 6.69683 11.6486 7.00879 11.9941L10.1973 15.5234C10.3556 15.6987 10.5795 15.799 10.8145 15.7998C11.0495 15.8005 11.2742 15.7017 11.4336 15.5273L16.4678 10.0215C16.7819 9.67773 16.7604 9.14149 16.4199 8.82422Z"
                fill="var(--color-icon-default)"/>
        </svg>
    );
}

export default CheckedIcon;
